import { createContext } from 'react';
import type { DeepLinkContextValue } from '../../types';

export const DeepLinkContext = createContext<DeepLinkContextValue | undefined>(undefined);
